export const GET_GROUP_MEMBER_START = 'GET_GROUP_MEMBER_START';
export const GET_GROUP_MEMBER_SUCCESS = 'GET_GROUP_MEMBER_SUCCESS';
export const GET_GROUP_MEMBER_ERROR = 'GET_GROUP_MEMBER_ERROR';
